export default function RangeDirective() {
  return {
    template: require('./range.component.html'),
    transclude: true,
    restrict: 'AE',
    scope: {
      range: '=ngModel',
      type: '=',
      form: '=',
      onSave: '=',
    },
    bindToController: true,
    controllerAs: 'vm',
    controller: RangeController,
  };

  function RangeController($scope) {
    'ngInject';
    let vm = this;

    vm.onMinSave = {};
    vm.onMaxSave = {};
    vm.onHideMin = onHideMin;
    vm.onHideMax = onHideMax;
    vm.onShowMin = onShowMin;
    vm.onShowMax = onShowMax;
    vm.minChanged = minChanged;
    vm.maxChanged = maxChanged;
    vm.rangeTypes = {
      number: 'number',
      date: 'date',
    };
    vm.$onInit = () => {
      vm.rangeType = getRangeType();

      vm.onSave.invoke = () => {
        if (vm.range.hasOwnProperty('min')) {
          vm.onMinSave.invoke();
        }

        if (vm.range.hasOwnProperty('max')) {
          vm.onMaxSave.invoke();
        }
      };
    };

    $scope.$watch(
      function () {
        return vm.range;
      },
      function () {
        vm.showMin = vm.range.hasOwnProperty('min');
        vm.showMax = vm.range.hasOwnProperty('max');
      },
    );

    function getRangeType() {
      switch (vm.type) {
        case 'Decimal':
        case 'Integer':
          return vm.rangeTypes.number;
        case 'Date':
        case 'Datetime':
          return vm.rangeTypes.date;
      }
    }

    function onHideMax() {
      delete vm.range['max'];
      GTM_StateChanged('MaxHidden');
    }

    function onHideMin() {
      delete vm.range['min'];
      GTM_StateChanged('MinHidden');
    }

    function onShowMax() {
      GTM_StateChanged('MaxShown');
    }

    function onShowMin() {
      GTM_StateChanged('MinShown');
    }

    function minChanged() {
      GTM_StateChanged('MinChanged');
    }
    function maxChanged() {
      GTM_StateChanged('MaxChanged');
    }

    function GTM_StateChanged(event) {
      window.dataLayer.push({
        event: `attributeRange${vm.type}${event}`,
      });
    }
  }
}
